module.exports = __webpack_public_path__ + "img/chain_banner_cyl.6f7c0642.png";